<template>
  <div class="terminal">
    <div class="terminal__img">
      <img src="@/assets/images/terminal.png" />
    </div>
    <div class="terminal__text">
      {{ $gettext(text) }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Счет можно оплатить в любом терминале Kaspi.",
    },
  },
};
</script>

<style lang="scss" scoped>
.terminal {
  padding: 42px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #999999;

  &__img {
    max-width: 56px;
    height: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__text {
    font-size: 16px;
  }
}
</style>
